import { datadogRum } from '@datadog/browser-rum';
import { defineNuxtPlugin } from 'nuxt/app';

export default defineNuxtPlugin((nuxtApp) => {
  const { ddApplicationId, ddApplicationToken, nuxtEnv } =
    useRuntimeConfig().public;
  if (nuxtEnv === 'development') return;

  datadogRum.init({
    applicationId: ddApplicationId,
    clientToken: ddApplicationToken,
    site: 'datadoghq.eu',
    service: 'career-website',
    env: nuxtEnv,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'allow',
  });
});
